<template>
  <section>
    <div
      class="relative bg-no-repeat bg-cover h-56 sm:h-96"
      :style="'background-image:url(' + this.headingContent.hero.image + ')'"
    >
      <div
        class="absolute bg-brand-blue-400 top-16 sm:top-32 right-0 p-2 sm:p-10 w-fit sm:w-fit"
      >
        <h1 class="flex-wrap text-2xl font-bold sm:text-5xl text-white">
          {{ this.headingContent.hero.title }}
        </h1>
        <div class="pt-2 pb-2 text-white text-md sm:text-xl text-center sm:text-left">
          {{ this.headingContent.hero.subtitle }}
        </div>
      </div>
    </div>
  </section>
  <div class="px-4">
    <div v-if="this.headingContent.page.title" class="container mx-auto mt-10 mb-4">
      <div class="gap-4 justify-center md:justify-start">
        <h1
          class="text-2xl text-brand-blue-400 font-display text-center md:text-left uppercase"
        >
          {{ this.headingContent.page.title }}
        </h1>
        <h3
          class="text-xl text-brand-blue-400 font-display uppercase text-center md:text-left"
        >
          {{ this.headingContent.page.subtitle }}
        </h3>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["headingContent"],
};
</script>
